var styles = {"radioButton":"bc-radio-button__radioButton","nativeRadioButton":"bc-radio-button__nativeRadioButton","radioButtonIcon":"bc-radio-button__radioButtonIcon","small":"bc-radio-button__small","large":"bc-radio-button__large"};

export { styles as default };
